/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystabSb } from '../../models/systab-sb';

export interface GetDataTypeById$Params {
  orid: number;
  sbid: number;
}

export function getDataTypeById(http: HttpClient, rootUrl: string, params: GetDataTypeById$Params, context?: HttpContext): Observable<StrictHttpResponse<SystabSb>> {
  const rb = new RequestBuilder(rootUrl, getDataTypeById.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
    rb.path('sbid', params.sbid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystabSb>;
    })
  );
}

getDataTypeById.PATH = '/api/MasterDataSource/dataTypesById/{orid}/{sbid}';
